/** `rangeArray` builds a array from the minimum number to the maximum number */
export const rangeArray = (min, max) => Array.from({length: max - min + 1}, (_, i) => min + i)
